/**
 * Bestsellers slider — mobile/tablet horizontal carousel.
 *
 * The same `bestsellers` collection renders twice on every collection
 * page (see snippets/b2b-bestsellers-widget.liquid):
 *   - As a vertical sidebar on >=1100 px desktop (no JS needed).
 *   - As a horizontal Swiper carousel on <1100 px (this file).
 *
 * The matching CSS visibility flips happen in b2b-collection-layout.css
 * — JS only initialises Swiper when the slider element is actually
 * present and visible. Re-runs on theme:section:load so Shopify's
 * theme editor section reloads pick the slider up too.
 */
(function () {
  'use strict';

  function initBestsellersSliders(scope) {
    const root = scope || document;
    const sliders = root.querySelectorAll('[data-b2b-bestsellers-slider] .swiper');
    if (!sliders.length) return;
    if (typeof window.Swiper === 'undefined') return;

    sliders.forEach(function (el) {
      // Already initialised? Skip — Swiper sets a `swiper` property on
      // the element once it's bound, and re-initialising would leak
      // event listeners on every section reload.
      if (el.swiper) return;

      // eslint-disable-next-line no-new
      new window.Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
          dynamicBullets: true,
        },
        breakpoints: {
          750: { spaceBetween: 16 },
          990: { spaceBetween: 20 },
        },
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBestsellersSliders();
    });
  } else {
    initBestsellersSliders();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBestsellersSliders(event.target);
  });
})();
